import { render, staticRenderFns } from "./DialogThesis.vue?vue&type=template&id=74e513ff&"
import script from "./DialogThesis.vue?vue&type=script&lang=js&"
export * from "./DialogThesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports